export const MODAL_OVERLAY_Z40_CLASS = "fixed inset-0 z-[9999] bg-black/50";
export const MODAL_OVERLAY_Z50_CLASS = "fixed inset-0 z-[10010] bg-black/50";
export const CONFIRM_DIALOG_OVERLAY_CLASS = "fixed inset-0 z-[9999] bg-black/50";
export const MODAL_CONTENT_CLASS = "z-[10000]";
export const NESTED_MODAL_CONTENT_CLASS = "z-[10020]";
